import React from 'react';
import { useFormState } from 'react-hook-form';
import styled from 'styled-components';
import { PrimaryButton } from '../../../../../Button';
import { IMeasureFilterState } from '../types';

const Container = styled.div`
  padding: 16px 12px 12px;
  text-align: right;
`;

const MeasureFilterFormSubmit = () => {
  const { isSubmitting, isValid, isDirty } =
    useFormState<IMeasureFilterState>();

  const isGreyedOut = !isValid || !isDirty; // disabled but clickable
  const disabled = (!isDirty && isValid) || isSubmitting; // not clickable

  return (
    <Container>
      <PrimaryButton
        type="submit"
        isGreyedOut={isGreyedOut}
        disabled={disabled}
        trackContext="measure filter"
        trackAction="confirm"
      >
        Confirm
      </PrimaryButton>
    </Container>
  );
};

export default MeasureFilterFormSubmit;
